
var questions = {
  'GoodEx.UniversalModels.Views.AdminTextQuestionView, GoodEx.UniversalModels': {
    label: 'Text',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminTextQuestionComparerView, GoodEx.UniversalModels'
    ]
  },
  'GoodEx.UniversalModels.Views.AdminDropdownListQuestionView, GoodEx.UniversalModels': {
    label: 'Dropdown',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminDropDownQuestionComparerView, GoodEx.UniversalModels',
    ]
  },
  'GoodEx.UniversalModels.Views.AdminMultipleChoiceQuestionView, GoodEx.UniversalModels': {
    label: 'Multiple Choice',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminMultipleChoiceQuestionComparerView, GoodEx.UniversalModels',
    ]
  },
  'GoodEx.UniversalModels.Views.AdminBooleanQuestionView, GoodEx.UniversalModels': {
    label: 'Boolean',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminBooleanQuestionComparerView, GoodEx.UniversalModels',
    ]
  },
  'GoodEx.UniversalModels.Views.AdminNumberQuestionView, GoodEx.UniversalModels': {
    label: 'Number',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminSingleNumberQuestionComparerView, GoodEx.UniversalModels',
      'GoodEx.UniversalModels.Views.AdminNumberRangeQuestionComparerView, GoodEx.UniversalModels'
    ]
  },
  'GoodEx.UniversalModels.Views.AdminSingleDateQuestionView, GoodEx.UniversalModels': {
    label: 'Date',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminSingleDateQuestionComparerView, GoodEx.UniversalModels',
      'GoodEx.UniversalModels.Views.AdminDateRangeQuestionComparerView, GoodEx.UniversalModels'
    ]
  },
  'GoodEx.UniversalModels.Views.AdminCurrencyQuestionView, GoodEx.UniversalModels': {
    label: 'Currency',
    comparers: [
      'GoodEx.UniversalModels.Views.AdminSingleCurrencyQuestionComparerView, GoodEx.UniversalModels',
      'GoodEx.UniversalModels.Views.AdminCurrencyRangeQuestionComparerView, GoodEx.UniversalModels'
    ]
  },
  'GoodEx.UniversalModels.Views.AdminGeoLocationQuestionView, GoodEx.UniversalModels': {
    label: 'Geolocation',
    comparers: []
  },
  'GoodEx.UniversalModels.Views.AdminCategoryQuestionView, GoodEx.UniversalModels': {
    label: 'Charitable Category',
    comparers: []
  },
  'GoodEx.UniversalModels.Views.AdminDocumentUploadQuestionView, GoodEx.UniversalModels': {
    label: 'Document Upload',
    comparers: []
  },
  'GoodEx.UniversalModels.Views.AdminTableQuestionView, GoodEx.UniversalModels': {
    label: 'Table',
    comparers: []
  },
  'GoodEx.UniversalModels.Views.AdminTableQuestionView, GoodEx.UniversalModels': {
    label: 'TotalsTable',
    comparers: []
  }
}

var comparers = {
  'GoodEx.UniversalModels.Views.AdminSingleNumberQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Number',
    comparisons: ['NotEqualTo', 'EqualTo', 'LessThan', 'GreaterThan'],
    check: function(comparer, question){
      if (comparer.comparisionType == 'NotEqualTo') {
        return question.answer != comparer.value;
      }

      if (comparer.comparisionType == 'EqualTo') {
        return question.answer == comparer.value;
      }

      if (comparer.comparisionType == 'LessThan') {
        return question.answer < comparer.value;
      }

      if (comparer.comparisionType == 'GreaterThan') {
        return question.answer > comparer.value;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminNumberRangeQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Number Range',
    comparisons: null,
    check: function(comparison, question){
      if (~question.$type.indexOf('Range')) {
        return question.min <= comparison.min && comparison.max >= question.max;
      } else {
        return question.value >= comparison.min && question.value <= comparison.max;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminSingleCurrencyQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Currency',
    comparisons: ['NotEqualTo', 'EqualTo', 'LessThan', 'GreaterThan'],
    check: function(comparer, question){
      if (comparer.comparisonType == 'NotEqualTo') {
        return question.value != comparer.value;
      }

      if (comparer.comparisonType == 'EqualTo') {
        return question.value == comparer.value;
      }

      if (comparer.comparisonType == 'LessThan') {
        return question.value < comparer.value;
      }

      if (comparer.comparisonType == 'GreaterThan') {
        return question.value > comparer.value;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminCurrencyRangeQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Currency Range',
    comparisons: null,
    check: function(comparison, question){
      if (~question.$type.indexOf('Range')) {
        return question.min <= comparison.min && comparison.max >= question.max;
      } else {
        return question.value >= comparison.min && question.value <= comparison.max;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminSingleDateQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Date',
    comparisons: ['NotEqualTo', 'EqualTo', 'LessThan', 'GreaterThan'],
    check: function(comparison, question){
      if (comparison.comparisonType == 'NotEqualTo') {
        return question.date != comparison.value;
      }

      if (comparison.comparisonType == 'EqualTo') {
        return question.date == comparison.value;
      }

      if (comparison.comparisonType == 'LessThan') {
        return question.date < comparison.value;
      }

      if (comparison.comparisonType == 'GreaterThan') {
        return question.date > comparison.value;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminDateRangeQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Date Range',
    comparisons: null,
    check: function(comparison, question){
      if (~question.$type.indexOf('Range')) {
        return question.min <= comparison.min && comparison.max >= question.max;
      } else {
        return question.date >= comparison.min && question.date <= comparison.max;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminTextQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Text',
    comparisons: ['NotEqualTo', 'EqualTo', 'Contains'],
    check: function(comparison, question){
      if (!question.answer) return null;
      if (comparison.comparisionType == "NotEqualTo") return question.answer !== comparison.value;
      if (comparison.comparisionType == "EqualTo") return question.answer === comparison.value;
      if (comparison.comparisionType == "Contains") return !!~question.answer.indexOf(comparison.value);
    }
  },
  'GoodEx.UniversalModels.Views.AdminBooleanQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Boolean',
    comparisons: null,
    check: function(comparison, question){
      var value = boolValue(question.checked);
      var c = boolValue(comparison.value);
      if (typeof value == 'boolean')  {
        if (c === value) return true;
        return false;
      }
    }
  },
  'GoodEx.UniversalModels.Views.AdminDropDownQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Dropdown',
    comparisons: null,
    check: function(comparison, question){
      return ~comparison.values.indexOf(question.answer);
    }
  },
  'GoodEx.UniversalModels.Views.AdminMultipleChoiceQuestionComparerView, GoodEx.UniversalModels': {
    label: 'Multiple Choice',
    comparisons: null,
    check: function(comparison, question){
      // this performs an ANY check.
      var values = comparison.answerIds;
      var answers = question.answer;
      // loop through selected values in comparer
      for (var i = 0; i < values.length; i++) {
        var v = values[i];
        // loop through answers
        for (var n = 0; n < answers.length; n++) {
          var a = answers[n];
          // match comparer values against question value
          // return true if match
          if (v && a.id && v === a.id) return true;
        }
      }
    }
  }
}


var comparisons = {
  'NotEqualTo': {
    label: 'Not Equal To'
  },
  'EqualTo': {
    label: 'Equal To'
  },
  'Contains': {
    label: 'Contains'
  },
  'GreaterThan': {
    label: 'Greater Than'
  },
  'LessThan': {
    label: 'Less Than'
  }
}


function toArray(obj) {
  return Object.keys(obj).map(function(k){
    var o = obj[k];
    o.key = k;
    return o;
  })
}



function expandQuestions() {
  var obj = {};

  Object.keys(questions).forEach(function(qkey){
    var q = questions[qkey];

    q.comparers = q.comparers.map(function(c){
      var comparer = comparers[c];
      comparer.key = c;
      return comparer;
    })

    obj[qkey] = q;
  })

  return obj;
}


function expandComparers(){
  var obj = {};

  Object.keys(comparers).forEach(function(ckey){
    var c = comparers[ckey];

    if (c.comparisons) {
      c.comparisons = c.comparisons.map(function(comparison){
        var o = comparisons[comparison];
        o.key = comparison;
        return o;
      })
    }

    obj[ckey] = c;
  })

  return obj;
}



var requestMaps = {
  'GoodEx.UniversalModels.Views.UserApplicationQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.UserApplicationQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationQuestionSetView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationQuestionSetRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationQuestionStepView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationQuestionStepRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationQuestionGroupView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationQuestionGroupRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminQuestionComparerRequest, GoodEx.UniversalModels'
  },

  'GoodEx.UniversalModels.Views.ApplicationTextQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationTextQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationBooleanQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationBooleanQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationNumberQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationNumberQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationNumberRangeQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationNumberRangeQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationCurrencyQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationCurrencyQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationCurrencyRangeQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationCurrencyRangeQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationDropdownListQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationDropdownListQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationMultipleChoiceQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationMultipleChoiceQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.MultipleChoiceQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.MultipleChoiceOptionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationSingleDateQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationSingleDateQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationDateRaneQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationDateRaneQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationGeoLocationQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationGeoLocationQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationCategoryQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationCategoryQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationDocumentUploadQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationDocumentUploadQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationTableQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationTableQuestionRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.ApplicationTotalsTableQuestionView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.ApplicationTotalsTableQuestionRequest, GoodEx.UniversalModels'
  },

  'GoodEx.UniversalModels.Views.AdminSingleNumberQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminSingleNumberQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminNumberRangeQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminNumberRangeQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminSingleCurrencyQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminSingleCurrencyQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminCurrencyRangeQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminCurrencyRangeQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminTextQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminTextQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminBooleanQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminBooleanQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminDropDownQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminDropDownQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminMultipleChoiceQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminMultipleChoiceQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminSingleDateQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminSingleDateQuestionComparerRequest, GoodEx.UniversalModels'
  },
  'GoodEx.UniversalModels.Views.AdminDateRangeQuestionComparerView, GoodEx.UniversalModels':
  {
    $type: 'GoodEx.UniversalModels.Request.AdminDateRangeQuestionComparerRequest, GoodEx.UniversalModels'
  },
}


exports.questions = expandQuestions();
exports.comparers = expandComparers();
exports.RequestMaps = toArray(requestMaps);



function boolValue(t){
  if (typeof t == 'string') {
    if (t=='true' || t=='True' || t=='TRUE') return true;
    if (t=='false' || t=='False' || t=='FALSE') return false;
  }
  if (typeof t == 'boolean') return t;
}
